import reducers from "./bookAnAppointmentReducers";

export default reducers;